import React from "react";
import { getReportCategory } from "../../../../graphql/queries";
import PropTypes from "prop-types";
import * as DataTypes from "../../../../constants/Data/DataTypes";
import GeneralInfo from "../../../Common/GeneralInfo";

const ReportCategoryGeneralInfo = (props) => {
  return (
    <GeneralInfo
      modelId={props.reportCategoryId}
      modelName={"ReportCategory"}
      listOfProperties={[
        {
          key: 1,
          attributeName: "name",
          attributeTitle: "Name",
          description: "Report Category Name",
          dataType: DataTypes.String,
        },
        {
          key: 2,
          attributeName: "order",
          attributeTitle: "Order",
          description: "Report Category Appearance Order",
          dataType: DataTypes.String,
        },
        {
          key: 3,
          attributeName: "createdAt",
          attributeTitle: "Created At",
          description: "Report Category Created At",
          dataType: DataTypes.DateTime,
        },
        {
          key: 4,
          attributeName: "updatedAt",
          attributeTitle: "Updated At",
          description: "Report Category Updated At",
          dataType: DataTypes.DateTime,
        },
      ]}
      queryFunction={getReportCategory}
      queryFunctionName={"getReportCategory"}
    />
  );
};

ReportCategoryGeneralInfo.propTypes = {
  reportCategoryId: PropTypes.string.isRequired,
};

export default ReportCategoryGeneralInfo;
